import React, { Component } from 'react';

import { Page, Breadcrumbs, Navigation } from 'components';

class Main extends Component {
  state = {
    breadcrumbs: [{ name: 'Home', to: '/' }, { name: 'Documentos', to: '' }],
    navigation: [
      { name: 'Lista de Documentos', to: '/documents/list' },
      { name: 'Razões de reprovação', to: '/reasons/list' },
    ],
  };

  render() {
    const { breadcrumbs, navigation } = this.state;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Navigation items={navigation} />
      </Page>
    );
  }
}

export default Main;
